import { render, staticRenderFns } from "./Packaging_dettaglio.vue?vue&type=template&id=7f00df5c&"
import script from "./Packaging_dettaglio.vue?vue&type=script&lang=js&"
export * from "./Packaging_dettaglio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports